import detailsSlideOutOpenerController from "./details-slide-out-opener-controller"

export default class extends detailsSlideOutOpenerController {
  static targets = ["slideOutContainer", "template"]

  connect() {
    this.open = this.open.bind(this)
    this.removeSlideOutAndOverlay = this.removeSlideOutAndOverlay.bind(this)
    App.Helpers.listenToCustomEvent(document, "details-slide-out:open", this.open)
    App.Helpers.listenToCustomEvent(document, "details-slide-out:close-all", this.removeSlideOutAndOverlay)
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "details-slide-out:open", this.open)
    App.Helpers.removeCustomEventListener(document, "details-slide-out:close-all", this.removeSlideOutAndOverlay)
  }

  open(event) {
    if (!this.slideOutContainerTarget.innerHTML) {
      this.setSlideOutDataAttrs(event.detail)
      App.Overlay.renderOverlay()
      this.slideOutContainerTarget.innerHTML = this.slideOutComponent.outerHTML
    }
  }

  removeSlideOutAndOverlay(event) {
    this.slideOutContainerTarget.innerHTML = ""
    App.Overlay.removeAllOverlays()
  }

  get slideOutDataAttrsPrefix() {
    return this.data.get("slide-out-data-attrs-prefix")
  }

  get templateHTML() {
    this._template = this._template || this.templateTarget.innerHTML
    return this._template
  }
}



// WEBPACK FOOTER //
// ./app/components/details/assets/javascript/details-slide-out-template-controller.js